import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Form               from 'app/components/forms/form';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/forms';


class PageFormShow extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {form, company} = this.props;

    return (
      <MainLayout className="page-form">
        <Meta title={`${form?.title || 'Form'} | Millie`} />
        {!!form && <Form form={form} company={company} />}
        <pre>{JSON.stringify({company}, null, 4)}</pre>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  form: FormsDuck.Slx.pgShowForm(state),
  company: FormsDuck.Slx.pgShowCompany(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageFormShow);
